export const isLoggedUser = (credential = {}) => credential?.status;

export const getUserId = (credential = {}) => credential.authInfo?.userId;
